import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import PerinHealthGrid from '../../components/PerinHealthGrid';
import FilterManagementView from '../../components/FilterManagementView';
import managementStyles from '../ManagementPages.module.css';
import useAxios from '../../services/AxiosConfig';
import { setReferenceCode, setRows, resetRefCodeState } from './ReferenceCodeSlice';
import { setAlertsPriorityCode, setAlertsPriorityRows, resetAlertsPriorityState } from './AlertsPrioritySlice';

const ReferenceCodeManagement = () => {
    const navigate = useNavigate();
    const dispatch = useDispatch();

    const [data, setData] = useState([]);

    const headers = [
        { key: 'name', label: "Name", sortable: true },
    ];
    
    const axiosConfig = useSelector((state) => state.axiosConfig);
    const axios = useAxios(axiosConfig.envURL);

   useEffect(() => {
        getReferenceCodeKeys();
        dispatch(resetRefCodeState())
        dispatch(resetAlertsPriorityState())
    }, []);

    const getReferenceCodeKeys = async () => {
        axios.get(`referenceCodeKeys`)
            .then((responseData) => {
                if (Array.isArray(responseData.data.data)) {
                    const referenceCodeKeys = [...responseData.data.data, {name: 'Alerts Priority', key: 'alertsPriority'}] 
                    setData(referenceCodeKeys);
                } else {
                    console.error('Invalid data format:');
                }
            })
            .catch((err) => {
                console.log(err);
            });
    };

    const fetchCodeValues = async (key) => {
        if (key === 'alertsPriority') {
            axios.get(`alertsPriority`)
            .then((responseData) => {
                if (Array.isArray(responseData.data.data)) {
                    dispatch(setAlertsPriorityRows(responseData.data.data))
                } else {
                    console.error('Invalid data format:');
                }
            })
            .catch((err) => {
                console.log(err);
            });
        } else {
            axios.get(`referenceCodes/${key}`)
            .then((responseData) => {
                if (Array.isArray(responseData.data.data)) {
                    dispatch(setRows(responseData.data.data))
                } else {
                    console.error('Invalid data format:');
                }
            })
            .catch((err) => {
                    console.log(err);
                });
        }
    };

    const onRowClickHandler = async (rowItem) => {
        if (rowItem.key === 'alertsPriority') {
            await fetchCodeValues(rowItem.key);
            navigate('/update-alerts-priority');
        } else {
            const readOnly = ['countryCode', 'stateCode', 'specialty', 'modality'].includes(rowItem.key);
            dispatch(setReferenceCode({...rowItem, readOnly: readOnly}));
            await fetchCodeValues(rowItem.key);
            navigate('/add-reference-code');
        }
    };

    const onUploadStandard = () => {
        console.log("uploading standard")
    };

    return (
        <div className={managementStyles.MiddleContent}>
            <FilterManagementView
                isOrganization={true}
                isGroup={false}
                isSubGroup={false}
                isTeam={false}
                addButtonLabel='Upload ALL from standard'
                onAddHandler={onUploadStandard}
                showDeleteButton={false}
            />
            <div className={managementStyles.GridContainer}>
                <PerinHealthGrid
                    dataList={data}
                    headers={headers}
                    showCheckbox={false}
                    showHeaderFilter={false}
                    showEditIcon={true}
                    onRowClick={onRowClickHandler}
                    gridHeight='100%'
                />     
            </div>
        </div>
    );
}

export default ReferenceCodeManagement;
